
// @ts-nocheck
declare var gGDPR_logoURL: string;

declare var gGDPR_privacyPolicyURL: string;

import { Emit, Component, Prop, Vue } from "vue-facing-decorator";
import SensitiveDataList from './SensitiveDataList.vue';
import ConsentItem from './ConsentItem.vue';

import {  UsDe } from '@iabgpp/cmpapi' 
import { updateCMPDelaware } from './updateCMPFuncs.js'

@Component({
  components: {
    SensitiveDataList,
    ConsentItem
  },
  props: {
    cmpApi: Object,
  },  

})

export default class LayerStateDaelaware extends Vue {

	privacyPageURL = "";
  forcedFixedPosition = false;
  logo_URL = typeof gGDPR_logoURL  == "string" ? gGDPR_logoURL : "";

  consentToSharing = true;
  consentToTargeting = true;
  sectionName = UsDe.NAME;
  sectionID = UsDe.ID;
  dirty = false;

  sensitiveLeadText = "Consent to the Use or Disclosure of the Consumer's Sensitive Personal Information:";
  sensitiveFeatures = [
    { position: 1, description: "Which Reveals a Consumer's Racial or Ethnic Origin." },
    { position: 2, description: "Which Reveals a Consumer's Religious Beliefs." },
    { position: 3, description: "Which Reveals a Consumer's Mental/physical health condition or diagnosis (including pregnancy)." },
    { position: 4, description: "Consisting of Personal Information Collected and Analyzed Concerning a Consumer's Sex Life or Sexual Orientation." },
    { position: 5, description: "Which Reveals a Consumer's Citizenship or immigration status." },
    { position: 6, description: "Which Reveals a Consumer's Genetic Data." },
    { position: 7, description: "Consisting of Biometric Information tor the Purpose of Uniquely Identifying a Consumer." },
    { position: 8, description: "Which Reveals a Consumer's Precise Geolocation." },
    { position: 9, description: "Which Reveals a Consumer's Transgender or nonbinary status." },
  ];

  mounted(): void {
    console.log("Daelaware Mounted");
    this.privacyPageURL = typeof gGDPR_privacyPolicyURL  == "string" ? gGDPR_privacyPolicyURL : "";

    if ( this.cmpApi.hasSection( this.sectionName ) ) {
      this.consentToSharing = this.cmpApi.getFieldValue(this.sectionName, 'SaleOptOut' ) == 2  ? true : false;
      this.consentToTargeting = this.cmpApi.getFieldValue(this.sectionName, 'TargetedAdvertisingOptOut') == 2  ? true : false;
    } else {
      updateCMPDelaware( true, this.cmpApi, this.consentToSharing, this.consentToTargeting )
    }  
  }

  sensitiveDataChange( consentArray ) {
    console.log("LayerStateDaelaware: sensitiveDataChange(): event=", consentArray);
    this.dirty = true;
  }

  @Emit('changeViewEvent')
	saveSettingsClick(consentToAll : Boolean): string {
    if ( consentToAll)  {
      this.consentToSharing = true;
      this.consentToTargeting = true;
    }

		updateCMPDelaware( consentToAll, this.cmpApi, this.consentToSharing, this.consentToTargeting )
    this.cmpApi.fireEvent( "sectionChanged", this.sectionName);
    return 'close'
	}
  
}
